import { RESET_PASSWORD_MUTATION } from "../queries";
import client from "/imports/client/services/apollo/client";
import hashPassword from "/imports/api/accounts/utils/hash-password";

const resetPasswordMutate = async (args: {
  token: string;
  password: string;
}) => {
  const { token, password } = args;
  const hashedPassword = hashPassword(password);
  const { errors, data } = await client.mutate({
    mutation: RESET_PASSWORD_MUTATION,
    variables: {
      input: {
        token,
        hashedPassword
      }
    }
  });

  // eslint-disable-next-line no-throw-literal
  if (errors?.length) throw errors?.[0];

  return data?.resetPassword;
};

export default resetPasswordMutate;
